<mat-form-field subscriptSizing="dynamic" appearance="outline" [class.slim]="slim">
  <mat-label><ng-content></ng-content></mat-label>
  <mat-chip-grid #chipList>
    @for (tagId of selectedTagIds; track tagId; let i = $index) {
      @if (tagsById[tagId] != null) {
        <mat-chip-row (removed)="remove(i)">
          {{ tagsById[tagId].name | localizedString }}
          <button matChipRemove><mat-icon>cancel</mat-icon></button>
        </mat-chip-row>
      }
    }
    <input
      placeholder="Tag eingeben"
      i18n-placeholder
      #tagInput
      [formControl]="tagCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="add($event)"
      (focus)="inputFocus$.next()"
    />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (tag of filteredTags$ | async; track tag) {
      <mat-option [value]="tag.id">{{ tag.name | localizedString }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
